import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataTable, DataTableField } from '../../../../components/data/DataTable';
import { API_ROUTES } from '../../../../core/Constants';
import { isRoot, setPage, useGlobal } from '../../../../core/Global';
import PBXServer from "../models/PBXServer";
import PBXServerForm from "./PBXServerForm";


function PBXServerList() {

  const [globalState, setGlobalState] = useGlobal();
  const navigate = useNavigate();

  const [formDrawer, formDrawerSet] = useState<boolean>(false);
  const [selectedId, selectedIdSet] = useState<string>();
  const [refresh, refreshSet] = useState<boolean>(false);

  useEffect(() => {
    if (!isRoot()) {
      navigate("/");
      return;
    }
    setPage("PBX Servers", "System");
  }, [])

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        refreshSet(false);
      }, 500);
    }
  }, [refresh])

  return (
    <>
      <DataTable objectName="Server"
        ascending
        apiRoute={API_ROUTES.PBXServers}
        refresh={refresh}
        edit
        addCustom={() => {
          selectedIdSet(undefined);
          formDrawerSet(true);
        }}
        editCustom={(data: PBXServer) => {
          selectedIdSet(data.id);
          formDrawerSet(true);
        }}>
        <DataTableField title="Name" dataValueName="name" />
        <DataTableField title="Host" dataValueName="host" />
      </DataTable>

      {
        formDrawer &&
        <PBXServerForm serverId={selectedId}
          onSave={() => refreshSet(true)}
          onClose={() => {
            selectedIdSet(undefined);
            formDrawerSet(false);
          }} />
      }
    </>
  );
}

export default PBXServerList;
